import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-processing-button__content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_button = _resolveComponent("base-button")
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-processing-button', $options.buttonStatusClass, {'is-processing': $props.isProcessing}])
  }, [
    _createVNode(_component_base_button, _mergeProps({..._ctx.$props, ..._ctx.$attrs}, { enabled: $options.isEnabled }), {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _: 3 /* FORWARDED */
    }, 16 /* FULL_PROPS */, ["enabled"]),
    ($options.hasStatusChanged)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['gfu-processing-button__status-icon', {'gfu-processing-button__spinner': !$options.isProcessingCompleted}])
        }, [
          ($options.isProcessingCompleted)
            ? (_openBlock(), _createBlock(_component_base_icon, {
                key: 0,
                name: $options.statusIcon,
                size: "lg",
                class: _normalizeClass($options.iconStatusClass)
              }, null, 8 /* PROPS */, ["name", "class"]))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}